module.exports = __webpack_public_path__ + "img/provider_new_games.41066d78.svg";